export default {
	NO_DATA: 'No Data in selected period',
	CSV: 'CSV',
	PDF: 'PDF'
};
